import axios from 'axios';

const BASE_URL = process.env.VUE_APP_APIURL;

const get = () => axios.get(`${BASE_URL}/api/TollRoadStatuses`).then((r) => r.data.map((i) => ({ Value: i.Id, Text: i.Name })));

export default {
    get,
};
